<!-- 资料变更历史 -->
<template>
   <div class='page_content'>
      <div class="page_content_top">
         <v-button :buttonList="buttonList" @actionSet="actionSet" @getPageInfo="getPageInfo" :buttonFlag="false"></v-button>
         <div class="page_content_top_line">
            <v-search v-if="formList.drugReport.length > 0" :searchList="formList.drugReport" :getRequestData="getRequestData" @searchData="searchData" @openSearchs="openSearch"></v-search>
         </div>
      </div>
      <div class="page_content_center">
         <el-table size="mini" stripe :data="returnData.list" :height="tableHeight" :key="$store.state.tableNum" border style="width: 100%" highlight-current-row>
            <el-table-column align="center" label="选择操作" width="80">
               <template slot-scope="scope">
                  <el-radio v-model="selectedDataIndex" :label="scope.$index" border size="mini">
                     <i class="el-icon-thumb"></i>
                  </el-radio>
               </template>
            </el-table-column>
            <el-table-column align="center" prop="patName" label="患者名称" show-overflow-tooltip min-width="130"></el-table-column>
            <el-table-column align="center" prop="patSex" label="性别" show-overflow-tooltip min-width="80"></el-table-column>
            <el-table-column align="center" prop="patDate" label="出生日期" show-overflow-tooltip min-width="120"></el-table-column>
            <el-table-column align="center" prop="patNat" label="民族" show-overflow-tooltip min-width="120"></el-table-column>
            <el-table-column align="center" prop="hospital" label="医院名称" show-overflow-tooltip min-width="120"></el-table-column>
            <el-table-column align="center" prop="oldDisease" label="原患疾病" show-overflow-tooltip min-width="120"></el-table-column>
            <el-table-column align="center" prop="isPrebad" label="既往药品不良反应/事件" show-overflow-tooltip min-width="150"></el-table-column>
            <el-table-column align="center" prop="isFamilybad" label="家族药品不良反应/事件" show-overflow-tooltip min-width="150"></el-table-column>
            <el-table-column align="center" prop="relInfo" label="相关重要信息" show-overflow-tooltip min-width="120"></el-table-column>
            <el-table-column align="center" prop="advName" label="不良反应/事件名称" show-overflow-tooltip min-width="150"></el-table-column>
            <el-table-column align="center" prop="advDate" label="不良反应/事件发生时间" show-overflow-tooltip min-width="150"></el-table-column>
            <el-table-column align="center" prop="advResult" label="不良反应/事件的结果" show-overflow-tooltip min-width="150"></el-table-column>
            <el-table-column align="center" prop="unitName" label="报告单位" show-overflow-tooltip min-width="120"></el-table-column>
            <el-table-column align="center" prop="unitDate" label="报告日期" show-overflow-tooltip min-width="120"></el-table-column>
            <el-table-column align="center" prop="remark" label="备注" show-overflow-tooltip min-width="120"></el-table-column>
            <el-table-column align="center" prop="createTime" label="创建时间" show-overflow-tooltip min-width="120">
               <template slot-scope="scope">
                  <span v-if="scope.row.createTime">
                     {{ $common.getLocalTime(scope.row.createTime) }}
                  </span>
               </template>
            </el-table-column>
         </el-table>
      </div>
      <div class="page_content_bottom">
         <v-pagination :page="getRequestData.page" :rows="getRequestData.rows" :total="returnData.total" @setDataPageSize="setDataPageSize" @setDataPageNumber="setDataPageNumber"></v-pagination>
      </div>
      <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth">
         <SearchScheme ref="searchScheme" :id="seId" @TranData="changeInputModel" :parentSearchData="parentSearchData" @getWidth="getSeWidth" @sendTitle="getSearchName" />
      </el-dialog>
      <el-dialog title="药品不良反应/事件报告表" center :visible.sync="drugShow" width="1200px" top="10px">
         <div class="box">
            <div class="space_between marginTop">
               <p>
                  <el-radio v-model="drugObj.repModel" label="首次报告">首次报告</el-radio>
                  <el-radio v-model="drugObj.repModel" label="跟踪报告">跟踪报告</el-radio>
               </p>
               <p class="align_items_center">
                  <span>编码：</span>
                  <el-input clearable style="width: 300px;" class="input" v-model="drugObj.badCode" size="mini"></el-input>
               </p>
            </div>
            <p class="align_items_center">
               <span>报告类型：</span>
               <el-radio v-model="drugObj.repType" label="新的">新的</el-radio>
               <el-radio v-model="drugObj.repType" label="严重">严重</el-radio>
               <el-radio v-model="drugObj.repType" label="一般">一般</el-radio>
            </p>
            <p class="align_items_center">
               <span>报告单位类别：</span>
               <el-radio v-model="drugObj.unitType" label="医疗机构">医疗机构</el-radio>
               <el-radio v-model="drugObj.unitType" label="经营企业">经营企业</el-radio>
               <el-radio v-model="drugObj.unitType" label="生产企业">生产企业</el-radio>
               <el-radio v-model="drugObj.unitType" label="个人">个人</el-radio>
               <el-radio v-model="drugObj.unitType" label="其他">其他</el-radio>
               <el-input clearable style="width: 300px;margin-left: 5px;" class="input" v-model="drugObj.unitOther" size="mini"></el-input>
            </p>
            <div class="box_center">
               <ul class="ul">
                  <li class="li ul_li align_items_center" style="min-width: 200px;">
                     <span class="li_title">患者姓名：</span>
                     <el-input clearable v-model="drugObj.patName" class="input" size="mini"></el-input>
                  </li>
                  <li class="li ul_li align_items_center" style="min-width: 120px;">
                     <span class="li_title">性别：</span>
                     <el-radio v-model="drugObj.patSex" label="男">男</el-radio>
                     <el-radio v-model="drugObj.patSex" label="女">女</el-radio>
                  </li>
                  <li class="li ul_li" style="min-width: 230px;">
                     <p class="align_items_center">
                        <span class="li_title">出生日期：</span>
                        <el-date-picker v-model="drugObj.patDate" type="date" placeholder="选择日期" format="yyyy年MM月dd日" size="mini" value-format="yyyy-MM-dd"></el-date-picker>
                     </p>
                     <p class="align_items_center" style="margin-top: 5px;">
                        <span class="li_title">或年龄：</span>
                        <el-input clearable class="input" v-model="drugObj.patAge" size="mini"></el-input>
                     </p>
                  </li>
                  <li class="li ul_li align_items_center" style="min-width: 180px;">
                     <span class="li_title">民族：</span>
                     <el-input clearable class="input" v-model="drugObj.patNat" size="mini"></el-input>
                  </li>
                  <li class="li ul_li align_items_center" style="min-width: 200px;">
                     <span class="li_title">体重（kg）：</span>
                     <el-input clearable class="input" type="number" v-model.trim="drugObj.patWeight" size="mini"></el-input>
                  </li>
                  <li class="li ul_li align_items_center" style="min-width: 200px;">
                     <span class="li_title">联系方式：</span>
                     <el-input clearable class="input" v-model="drugObj.patPhone" size="mini"></el-input>
                  </li>
               </ul>
               <ul class="ul">
                  <li class="li ul_li1 align_items_start">
                     <span class="li_title">原患疾病：</span>
                     <el-input clearable v-model="drugObj.oldDisease" type="textarea" :rows="3" size="mini"></el-input>
                  </li>
                  <li class="li ul_li1">
                     <p class="align_items_center">
                        <span class="li_title">医院名称：</span>
                        <el-input clearable class="input" v-model="drugObj.hospital" size="mini"></el-input>
                     </p>
                     <p class="align_items_center" style="margin-top: 5px;">
                        <span class="li_title">病历号/门诊号：</span>
                        <el-input clearable class="input" v-model="drugObj.medCode" size="mini"></el-input>
                     </p>
                  </li>
                  <li class="li ul_li1" style="min-width: 500px;">
                     <p class="align_items_center">
                        <span class="li_title">既往药品不良反应/事件：</span>
                        <el-radio v-model="drugObj.isPrebad" label="有">有</el-radio>
                        <el-input clearable class="input" v-model="drugObj.prebad" style="width: 150px;" size="mini"></el-input>
                        <el-radio v-model="drugObj.isPrebad" label="无" style="margin-left: 10px;">无</el-radio>
                        <el-radio v-model="drugObj.isPrebad" label="不详">不详</el-radio>
                     </p>
                     <p class="align_items_center" style="margin-top: 5px;">
                        <span class="li_title">家族药品不良反应/事件：</span>
                        <el-radio v-model="drugObj.isFamilybad" label="有">有</el-radio>
                        <el-input clearable class="input" v-model="drugObj.familybad" style="width: 150px;" size="mini"></el-input>
                        <el-radio v-model="drugObj.isFamilybad" label="无" style="margin-left: 10px;">无</el-radio>
                        <el-radio v-model="drugObj.isFamilybad" label="不详">不详</el-radio>
                     </p>
                  </li>
               </ul>
               <p class="align_items_center " style="padding: 5px;">
                  <span class="li_title">相关重要信息：</span>
                  <el-radio v-model="drugObj.relInfo" label="吸烟史">吸烟史</el-radio>
                  <el-radio v-model="drugObj.relInfo" label="饮酒史">饮酒史</el-radio>
                  <el-radio v-model="drugObj.relInfo" label="妊娠期">妊娠期</el-radio>
                  <el-radio v-model="drugObj.relInfo" label="肝病史">肝病史</el-radio>
                  <el-radio v-model="drugObj.relInfo" label="肾病史">肾病史</el-radio>
                  <el-radio v-model="drugObj.relInfo" label="过敏史">过敏史</el-radio>
                  <el-input clearable class="input" v-model="drugObj.allergyRemark" style="width: 150px;margin-right: 10px;" size="mini"></el-input>
                  <el-radio v-model="drugObj.relInfo" label="其他">其他</el-radio>
                  <el-input clearable class="input" v-model="drugObj.otherRemark" style="width: 150px;" size="mini"></el-input>
               </p>
               <div class="table" style="padding: 5px;">
                  <div class="btn align_items_center">
                     <el-button type="primary" size="mini" @click="addClick('hydetails')">新 增</el-button>
                     <el-button type="danger" size="mini" @click="delClick('hydetails','selectedDetailsIndex')">删 除</el-button>
                     <h3 style="margin-left: 10px;">怀 疑 药 品</h3>
                  </div>
                  <el-table :data="drugObj.hydetails" style="width: 100%" border height="300">
                     <el-table-column width="80" label="选择" fixed="left">
                        <template slot-scope="scope">
                           <el-radio v-model="selectedDetailsIndex" :label="scope.$index" border size="mini">
                              <i class="el-icon-thumb"></i>
                           </el-radio>
                        </template>
                     </el-table-column>
                     <el-table-column prop="bgiAppnumber" label="批准文号" min-width="150" show-overflow-tooltip></el-table-column>
                     <el-table-column prop="bgmName" label="通用名称" min-width="180" show-overflow-tooltip>
                        <template slot-scope="scope">
                           <el-input clearable v-model="scope.row.bgmName" ref="bgmName" id="bgmName"
                                     @keyup.enter.native="openSearch(7067112496762880, scope.$index, 'bgmName', 'bgmName,bgmId,bgiProrangeName,manufacturer,batchno,bgiAppnumber', 'hydetails')">
                              <el-button @click="openSearch(7067112496762880, scope.$index, 'bgmName', 'bgmName,bgmId,bgiProrangeName,manufacturer,batchno,bgiAppnumber', 'hydetails')" slot="append" icon="el-icon-search">
                              </el-button>
                           </el-input>
                        </template>
                     </el-table-column>
                     <el-table-column prop="bgiProrangeName" label="通用名称（含剂型）" min-width="180" show-overflow-tooltip></el-table-column>
                     <el-table-column prop="manufacturer" label="生产厂家" min-width="180" show-overflow-tooltip></el-table-column>
                     <el-table-column prop="batchno" label="生产批号" min-width="120" show-overflow-tooltip>
                        <template slot-scope="scope">
                           <el-input clearable class="input" v-model="scope.row.batchno" size="mini" ref="batchno" @keyup.enter.native="tableNextFocus('useDosage',scope.$index)"></el-input>
                        </template>
                     </el-table-column>
                     <el-table-column prop="useDosage" label="用法用量（次剂量、途径、日次数）" min-width="200" show-overflow-tooltip>
                        <template slot-scope="scope">
                           <el-input clearable class="input" v-model="scope.row.useDosage" type="number" size="mini" ref="useDosage" @keyup.enter.native="tableNextFocus('mediDate',scope.$index)"></el-input>
                        </template>
                     </el-table-column>
                     <el-table-column prop="mediDate" label="用药起止时间" min-width="150" show-overflow-tooltip>
                        <template slot-scope="scope">
                           <el-input clearable class="input" v-model="scope.row.mediDate" size="mini" ref="mediDate" @keyup.enter.native="tableNextFocus('mdiReason',scope.$index)"></el-input>
                        </template>
                     </el-table-column>
                     <el-table-column prop="mdiReason" label="用药原因" min-width="150" show-overflow-tooltip>
                        <template slot-scope="scope">
                           <el-input clearable class="input" v-model="scope.row.mdiReason" size="mini" @keyup.enter.native="tableNextFocus('keydown',scope.$index)"></el-input>
                        </template>
                     </el-table-column>
                  </el-table>
               </div>
               <div class="table" style="padding: 5px;">
                  <div class="btn align_items_center">
                     <el-button type="primary" size="mini" @click="addClick('bydetails')">新 增</el-button>
                     <el-button type="danger" size="mini" @click="delClick('bydetails','selectedDetailsIndex1')">删 除</el-button>
                     <h3 style="margin-left: 10px;">并 用 药 品</h3>
                  </div>
                  <el-table :data="drugObj.bydetails" style="width: 100%" border height="300">
                     <el-table-column width="80" label="选择" fixed="left">
                        <template slot-scope="scope">
                           <el-radio v-model="selectedDetailsIndex1" :label="scope.$index" border size="mini">
                              <i class="el-icon-thumb"></i>
                           </el-radio>
                        </template>
                     </el-table-column>
                     <el-table-column prop="bgiAppnumber" label="批准文号" min-width="150" show-overflow-tooltip></el-table-column>
                     <el-table-column prop="bgmName" label="通用名称" min-width="180" show-overflow-tooltip>
                        <template slot-scope="scope">
                           <el-input clearable v-model="scope.row.bgmName" ref="bgmName1" id="bgmName1"
                                     @keyup.enter.native="openSearch(7067112496762880, scope.$index, 'bgmName', 'bgmName,bgmId,bgiProrangeName,manufacturer,batchno,bgiAppnumber', 'bydetails')">
                              <el-button @click="openSearch(7067112496762880, scope.$index, 'bgmName', 'bgmName,bgmId,bgiProrangeName,manufacturer,batchno,bgiAppnumber', 'bydetails')" slot="append" icon="el-icon-search">
                              </el-button>
                           </el-input>
                        </template>
                     </el-table-column>
                     <el-table-column prop="bgiProrangeName" label="通用名称（含剂型）" min-width="180" show-overflow-tooltip></el-table-column>
                     <el-table-column prop="manufacturer" label="生产厂家" min-width="180" show-overflow-tooltip></el-table-column>
                     <el-table-column prop="batchno" label="生产批号" min-width="120" show-overflow-tooltip>
                        <template slot-scope="scope">
                           <el-input clearable class="input" v-model="scope.row.batchno" size="mini" ref="batchno1" @keyup.enter.native="tableNextFocus('useDosage1',scope.$index)"></el-input>
                        </template>
                     </el-table-column>
                     <el-table-column prop="address" label="用法用量（次剂量、途径、日次数）" min-width="200" show-overflow-tooltip>
                        <template slot-scope="scope">
                           <el-input clearable class="input" v-model="scope.row.useDosage" type="number" size="mini" ref="useDosage1" @keyup.enter.native="tableNextFocus('mediDate1',scope.$index)"></el-input>
                        </template>
                     </el-table-column>
                     <el-table-column prop="address" label="用药起止时间" min-width="150" show-overflow-tooltip>
                        <template slot-scope="scope">
                           <el-input clearable class="input" v-model="scope.row.mediDate" size="mini" ref="mediDate1" @keyup.enter.native="tableNextFocus('mdiReason1',scope.$index)"></el-input>
                        </template>
                     </el-table-column>
                     <el-table-column prop="address" label="用药原因" min-width="150" show-overflow-tooltip>
                        <template slot-scope="scope">
                           <el-input clearable class="input" v-model="scope.row.mdiReason" size="mini" ref="mdiReason1" @keyup.enter.native="tableNextFocus('keydown',scope.$index)"></el-input>
                        </template>
                     </el-table-column>
                  </el-table>
               </div>
               <ul class="ul">
                  <li class="li ul_li2 align_items_center ">
                     <span class="li_title">不良反应/事件名称：</span>
                     <el-input clearable class="input" v-model="drugObj.advName" size="mini"></el-input>
                  </li>
                  <li class="li ul_li2 align_items_center ">
                     <span class="li_title">不良反应/事件发生时间：</span>
                     <el-date-picker v-model="drugObj.advDate" type="date" placeholder="选择日期" format="yyyy年MM月dd日" size="mini" value-format="yyyy-MM-dd"></el-date-picker>
                  </li>
               </ul>
               <p style="padding: 5px;">
                  <span class="li_title">不良反应/事件过程描述（包括症状、体征、临床检验等）及处理情况（可附页）：</span>
                  <el-input clearable style="margin-top: 5px;" v-model="drugObj.advHand" type="textarea" :rows="5" size="mini"></el-input>
               </p>
               <ul class="ul">
                  <li class="li ul_li3 align_items_start ">
                     <span class="li_title" style="margin-top: 2px;">不良反应/事件的结果：</span>
                     <div>
                        <div class="align_items_center" style="margin-bottom: 5px;">
                           <el-radio v-model="drugObj.advResult" label="痊愈">痊愈</el-radio>
                           <el-radio v-model="drugObj.advResult" label="好转">好转</el-radio>
                           <el-radio v-model="drugObj.advResult" label="未好转">未好转</el-radio>
                           <el-radio v-model="drugObj.advResult" label="不详">不详</el-radio>
                           <el-radio v-model="drugObj.advResult" label="有后遗症">有后遗症</el-radio>
                           <p class="align_items_center">
                              <span class="li_title">表现：</span>
                              <el-input clearable class="input" v-model="drugObj.effectsPerf" style="width: 200px;" size="mini"></el-input>
                           </p>
                        </div>
                        <div class="align_items_center">
                           <el-radio v-model="drugObj.advResult" label="死亡" style="margin-top: 2px;">死亡</el-radio>
                           <p class="align_items_center">
                              <span class="li_title">直接死因：</span>
                              <el-input clearable class="input" v-model="drugObj.deathReason" style="width: 200px;" size="mini"></el-input>
                           </p>
                           <p class="align_items_center" style="margin-left: 5px;">
                              <span class="li_title">死亡时间：</span>
                              <el-date-picker v-model="drugObj.deathDate" type="date" placeholder="选择日期" format="yyyy年MM月dd日" size="mini" value-format="yyyy-MM-dd"></el-date-picker>
                           </p>
                        </div>
                     </div>
                  </li>
               </ul>
               <ul class="ul">
                  <li class="li ul_li4">
                     <p class="align_items_center">
                        <span class="li_title" style="display: inline-block; width: 350px;text-align: left;">停药或减量后，反应/事件是否消失或减轻？</span>
                        <el-radio v-model="drugObj.isReduce" label="是">是</el-radio>
                        <el-radio v-model="drugObj.isReduce" label="否">否</el-radio>
                        <el-radio v-model="drugObj.isReduce" label="不明">不明</el-radio>
                        <el-radio v-model="drugObj.isReduce" label="未停药或未减量">未停药或未减量</el-radio>
                     </p>
                     <p class="align_items_center" style="margin-top: 5px;">
                        <span class="li_title" style="display: inline-block; width: 350px;text-align: left;">再次使用可疑药品后是否再次出现同样反应/事件？</span>
                        <el-radio v-model="drugObj.isAgain" label="是">是</el-radio>
                        <el-radio v-model="drugObj.isAgain" label="否">否</el-radio>
                        <el-radio v-model="drugObj.isAgain" label="不明">不明</el-radio>
                        <el-radio v-model="drugObj.isAgain" label="未再使用">未再使用</el-radio>
                     </p>
                  </li>
               </ul>
               <p class="align_items_center" style="padding: 5px;">
                  <span class="li_title">对原患疾病的影响：</span>
                  <el-radio v-model="drugObj.oldEffect" label="不明显">不明显</el-radio>
                  <el-radio v-model="drugObj.oldEffect" label="病程延长">病程延长</el-radio>
                  <el-radio v-model="drugObj.oldEffect" label="病情加重">病情加重</el-radio>
                  <el-radio v-model="drugObj.oldEffect" label="导致后遗症">导致后遗症</el-radio>
                  <el-radio v-model="drugObj.oldEffect" label="导致死亡">导致死亡</el-radio>
               </p>
               <ul class="ul">
                  <li class="li ul_li5 align_items_center" style="width: 150px;justify-content: center;flex-shrink: 0;">关联性评价</li>
                  <li class="li ul_li5" style="width: calc(100vw - 150px);">
                     <p class="align_items_center">
                        <span class="li_title" style="display: inline-block; width: 120px;text-align: left;">报告人评价：</span>
                        <el-radio v-model="drugObj.userEva" label="肯定">肯定</el-radio>
                        <el-radio v-model="drugObj.userEva" label="很可能">很可能</el-radio>
                        <el-radio v-model="drugObj.userEva" label="可能无关">可能无关</el-radio>
                        <el-radio v-model="drugObj.userEva" label="待评价">待评价</el-radio>
                        <el-radio v-model="drugObj.userEva" label="无法评价">无法评价</el-radio>
                        <span class="li_title">签名：</span>
                        <el-input clearable class="input" v-model="drugObj.repSign" style="width: 200px;" size="mini"></el-input>
                     </p>
                     <p class="align_items_center" style="margin-top: 5px;">
                        <span class="li_title" style="display: inline-block; width: 120px;text-align: left;">报告单位评价：</span>
                        <el-radio v-model="drugObj.unitEva" label="肯定">肯定</el-radio>
                        <el-radio v-model="drugObj.unitEva" label="很可能">很可能</el-radio>
                        <el-radio v-model="drugObj.unitEva" label="可能无关">可能无关</el-radio>
                        <el-radio v-model="drugObj.unitEva" label="待评价">待评价</el-radio>
                        <el-radio v-model="drugObj.unitEva" label="无法评价">无法评价</el-radio>
                        <span class="li_title">签名：</span>
                        <el-input clearable class="input" v-model="drugObj.unitSgin" style="width: 200px;" size="mini"></el-input>
                     </p>
                  </li>
               </ul>
               <ul class="ul">
                  <li class="li align_items_center" style="width: 150px;justify-content: center;flex-shrink: 0;">报告人信息</li>
                  <li style="width: calc(100vw - 150px);">
                     <div class="align_items_center " style="border-right: none;">
                        <p class="align_items_center li" style="min-width: 250px;">
                           <span class="li_title">联系电话：</span>
                           <el-input clearable class="input" v-model="drugObj.userPhone" size="mini"></el-input>
                        </p>
                        <p class="align_items_center li" style="width: 100%;">
                           <span class="li_title">职业：</span>
                           <el-radio v-model="drugObj.userCareer" label="医生">医生</el-radio>
                           <el-radio v-model="drugObj.userCareer" label="药师">药师</el-radio>
                           <el-radio v-model="drugObj.userCareer" label="护士">护士</el-radio>
                           <el-radio v-model="drugObj.userCareer" label="其他">其他</el-radio>
                           <el-input clearable class="input" v-model="drugObj.careerOther" style="width: 200px;" size="mini"></el-input>
                        </p>
                     </div>
                     <div class="align_items_center">
                        <p class="align_items_center li" style="width: 100%;">
                           <span class="li_title">电子邮箱：</span>
                           <el-input clearable class="input" v-model="drugObj.userEmail" size="mini"></el-input>
                        </p>
                        <p class="align_items_center li" style="width: 100%;">
                           <span class="li_title">签名：</span>
                           <el-input clearable class="input" v-model="drugObj.userSgin" size="mini"></el-input>
                        </p>
                     </div>
                  </li>
               </ul>
               <ul class="ul">
                  <li class="li align_items_center" style="width: 150px;justify-content: center;flex-shrink: 0;">报告单位信息</li>
                  <li class="li align_items_center">
                     <span class="li_title">单位名称：</span>
                     <el-input clearable style="width: 250px;" class="input" v-model="drugObj.unitName" size="mini"></el-input>
                  </li>
                  <li class="li align_items_center">
                     <span class="li_title">联系人：</span>
                     <el-input clearable class="input" v-model="drugObj.unitLink" size="mini"></el-input>
                  </li>
                  <li class="li align_items_center">
                     <span class="li_title">电话：</span>
                     <el-input clearable class="input" v-model="drugObj.unitPhone" size="mini"></el-input>
                  </li>
                  <li class="li align_items_center">
                     <span class="li_title">报告日期：</span>
                     <el-date-picker v-model="drugObj.unitDate" type="date" placeholder="选择日期" format="yyyy年MM月dd日" size="mini" value-format="yyyy-MM-dd"></el-date-picker>
                  </li>
               </ul>
               <ul class="ul">
                  <li class="li align_items_center" style="width: 150px;justify-content: center;flex-shrink: 0;">生产企业请填写信息来源</li>
                  <li class="li align_items_center" style="width: 100%;">
                     <el-radio v-model="drugObj.infoResource" label="医疗机构">医疗机构</el-radio>
                     <el-radio v-model="drugObj.infoResource" label="经营企业">经营企业</el-radio>
                     <el-radio v-model="drugObj.infoResource" label="个人">个人</el-radio>
                     <el-radio v-model="drugObj.infoResource" label="文献报道">文献报道</el-radio>
                     <el-radio v-model="drugObj.infoResource" label="上市后研究">上市后研究</el-radio>
                     <el-radio v-model="drugObj.infoResource" label="其他">其他</el-radio>
                     <el-input clearable style="width: 250px;" class="input" v-model="drugObj.infoOther" size="mini"></el-input>
                  </li>
               </ul>
               <ul class="ul">
                  <li class="li ul_li6 align_items_center" style="width: 150px;justify-content: center;flex-shrink: 0;">备 注</li>
                  <li class="li ul_li6 align_items_center" style="width: 100%;">
                     <el-input clearable style="width: 100%;" class="input" v-model="drugObj.remark" size="mini"></el-input>
                  </li>
               </ul>
            </div>
         </div>
         <div class="floor">
            <el-button type="primary" size="mini" @click="initActionBox">取消</el-button>
            <el-button type="primary" style="margin-left: 20px !important;" size="mini" @click="sendDataAction">保 存</el-button>
         </div>
      </el-dialog>
   </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import formList from './drug'
import SearchScheme from "../../byComponents/SearchScheme.vue";
export default {
   name: "drugReport",
   //import引入的组件需要注入到对象中才能使用
   components: { SearchScheme },
   data() {
      //这里存放数据
      return {
         tableHeight: 0,
         getRequestData: {
            gchmType: '',
            page: 1,
            rows: 30,
            start: '',
            end: '',
            chanName: '',
            createrName: "",
         },
         returnData: {
            pages: 0, // 总页数
            total: 0, // 总条数
            pageNum: 0, // 当前页数
            list: []
         },

         buttonList: [],
         selectedDataIndex: 0,
         showStatus: false,
         actionData: {},
         formList: formList,
         DialogVisible: false,
         seId: "",
         seTitle: "",
         seWidth: "",
         parentSearchData: {},
         sField: "",
         //---------------药品不良反应/事件报告表
         drugShow: false,
         drugType: 0,
         tableType: "",
         selectedDetailsIndex: 0,
         selectedDetailsIndex1: 0,
         bydetails: {
            "badId": 0,
            "badType": 1,
            "batchno": "",
            "bgiAppnumber": "",
            "bgiProrangeName": "",
            "bgmName": "",
            "id": 0,
            "manufacturer": "",
            "mdiReason": "",
            "mediDate": "",
            "rowno": 0,
            "useDosage": "",
         },
         hydetails: {
            "badId": 0,
            "badType": 0,
            "batchno": "",
            "bgiAppnumber": "",
            "bgiProrangeName": "",
            "bgmName": "",
            "id": 0,
            "manufacturer": "",
            "mdiReason": "",
            "mediDate": "",
            "rowno": 0,
            "useDosage": ""
         },
         drugObj: {
            "advDate": "",
            "advHand": "",
            "advName": "",
            "advResult": "",
            "allergyRemark": "",
            "badCode": "",
            "badId": 0,
            "bydetails": [],
            "careerOther": "",
            "createTime": 0,
            "creater": 0,
            "deathDate": "",
            "deathReason": "",
            "effectsPerf": "",
            "familybad": "",
            "hospital": "",
            "hydetails": [],
            "infoOther": "",
            "infoResource": "",
            "isAgain": "",
            "isFamilybad": "",
            "isPrebad": "",
            "isReduce": "",
            "medCode": "",
            "oldDisease": "",
            "oldEffect": "",
            "ormId": 0,
            "otherRemark": "",
            "patAge": "",
            "patDate": "",
            "patName": "",
            "patNat": "",
            "patPhone": "",
            "patSex": "",
            "patWeight": "",
            "prebad": "",
            "relInfo": "",
            "remark": "",
            "repModel": "",
            "repSign": "",
            "repType": "",
            "unitDate": "",
            "unitEva": "",
            "unitLink": "",
            "unitName": "",
            "unitOther": "",
            "unitPhone": "",
            "unitSgin": "",
            "unitType": "",
            "userCareer": "",
            "userEmail": "",
            "userEva": "",
            "userPhone": "",
            "userSgin": ""
         }
      };
   },
   //监听属性 类似于data概念
   computed: {},
   //监控data中的数据变化
   watch: {
      'getRequestData.gchmType': {
         handler: function (newValue, oldValue) {
            this.searchData()
         },
         deep: true,
      }
   },
   //方法集合
   methods: {
      // 表格切换焦点方法
      tableNextFocus(field, index) {
         console.log(this.drugObj, "测试");

         if (field == "keydown") {
            return;
         }
         this.$nextTick(() => {
            if (this.$refs[field][index]) {
               this.$refs[field][index].focus();
            } else {
               this.$refs[field].focus();
            }
         })
      },
      initData() {
         for (const key in this.drugObj) {
            if (key == 'bydetails' || key == 'hydetails') {
               this.drugObj[key] = []
            } else {
               this.drugObj[key] = ""
            }
         }
      },
      //取消
      initActionBox(val) {
         if (val) {
            this.getDataList()
         }
         this.drugShow = false
      },
      async sendDataAction() {
         let responseData;
         if (this.drugType == 0) {
            responseData = await this.$http.ymbadaddBad(this.drugObj)
         } else if (this.drugType == 1) {
            responseData = await this.$http.ymbadupdBad(this.drugObj)
         }
         if (responseData.status == 200) {
            this.$message({
               message: "操作成功",
               type: "success",
            });
            this.initActionBox(true)
            this.initData()
         } else {
            this.$message({
               message: responseData.message,
               type: "error",
            });
         }
      },
      // 点击穿透字段 传参单号
      toDetail(orderId) {
         if (orderId) {
            // 设置为true 打开穿透组件首页
            var isPenetrate = true;
            // 设置缓存 存入点击单号
            this.resetSetItem("penetrateOrderId", orderId);
            // 与父级跨域通信 传递isPenetrate参数
            window.parent.postMessage(
               {
                  //向窗口发送MessageEvent消息
                  cmd: "returnFormJson",
                  params: { isPenetrate }, //参数
               },
               "*"
            );
         }
      },
      getSeWidth(e) {
         this.seWidth = e + "%";
      },
      getSearchName(e) {
         this.seTitle = e;
      },
      // 检索Id, 索引(表格中), 标识ppamId
      openSearch(sId, index, type, sField, tableType) {
         this.DialogVisible = true;
         this.tableType = tableType
         this.seId = sId;
         this.seIndex = index;
         this.seType = type;
         this.sField = sField
         this.parentSearchData[type] = this.getRequestData[type]
      },
      changeInputModel(val) {
         if (val != "" || val != undefined) {
            this.DialogVisible = false;
            this.paramValue(val)
         }
      },
      // 赋值字段
      paramValue(val) {
         let arr = this.sField.split(',')
         arr.forEach(item => {
            if (this.tableType == 'hydetails') {
               this.selectedDetailsIndex = this.seIndex
               this.drugObj[this.tableType][this.selectedDetailsIndex][item] = val[item]
            } else if (this.tableType == 'bydetails') {
               this.selectedDetailsIndex1 = this.seIndex
               this.drugObj[this.tableType][this.selectedDetailsIndex1][item] = val[item]
            } else {
               this.getRequestData[item] = val[item]
            }
         })
         if (this.tableType == 'hydetails') {
            this.tableNextFocus('batchno', this.seIndex)
         } else if (this.tableType == 'bydetails') {
            this.tableNextFocus('batchno1', this.seIndex)
         }
      },
      // 子组件触发
      drawerCancel(commitData) {
         this.showStatus = false
         commitData && this.getDataList()
      },
      getPageInfo() {
         this.getDataList()
      },
      lookDetail(data) {
         this.queryDetails(data)
      },
      async queryDetails(dataInfo) {
         const res = await this.$http.flowInstancequeryInfo({ ids: [dataInfo.wfiId] })
         if (res.status = 200) {
            let responseData = await this.$http.flowDeinitqueryDeinitionById({ ids: [dataInfo.wfdId] });
            if (responseData && responseData.status == 200) {
               this.actionData = {
                  cate: 2,
                  wfdId: dataInfo.wfdId,
                  wfiId: res.result.wfiId,
                  wdfForm: responseData.result.wdfForm,
                  wfiContent: res.result.wfiContent,
                  wfdName: res.result.wfdName,
                  wfiRemark: res.result.wfiRemark,
               }
               this.showStatus = true
            } else {
               this.$message({
                  message: responseData.message,
                  type: "error",
               });
            }
         }
      },
      // 动作集合
      actionSet(actionData) {
         switch (actionData.actionType) {
            case 0:
               this.initData()
               this.drugShow = true
               this.drugType = 0
               break;
            case 1:
               if (!this.returnData.list[this.selectedDataIndex]) {
                  this.$message({
                     message: '请先选择您要操作的数据',
                     type: 'error'
                  });
                  return false
               }
               this.initData()
               var dataInfo = JSON.parse(JSON.stringify(this.returnData.list[this.selectedDataIndex]))
               for (const key in this.drugObj) {
                  if (dataInfo[key]!=undefined&&dataInfo[key]!==""&&dataInfo[key]!=null) {
                     this.drugObj[key] = dataInfo[key];
                  }
               }
               this.drugShow = true
               this.drugType = 1
               break;
            case 2:
               if (!this.returnData.list[this.selectedDataIndex]) {
                  this.$message({
                     message: '请先选择您要操作的数据',
                     type: 'error'
                  });
                  return false
               }
               var dataInfo = JSON.parse(JSON.stringify(this.returnData.list[this.selectedDataIndex]))
               this.del(dataInfo)
               break;
         }
      },
      async del(dataInfo) {
         const responseData = await this.$http.ymbaddelBad({ ids: [dataInfo.badId] })
         if (responseData.status == 200) {
            this.$message({
               message: "删除成功",
               type: "success",
            });
            this.getDataList()
         } else {
            this.$message({
               message: responseData.message,
               type: "error",
            });
         }
      },
      // 数据搜索
      searchData() {
         this.getRequestData.page = 1
         this.getDataList()
      },
      // 数据翻页
      setDataPageNumber(val) {
         this.getRequestData.page = val
         this.getDataList()
      },

      // 切换显示条数
      setDataPageSize(val) {
         this.getRequestData.page = 1
         this.getRequestData.rows = val
         this.getDataList()
      },


      // 获取数据列表
      async getDataList() {
         let responseData = await this.$http.ymbadqueryBad(this.getRequestData)
         if (responseData.status == 200) {
            this.returnData.list = responseData.result.list
            this.returnData.pages = responseData.result.pages
            this.returnData.total = responseData.result.total
            this.returnData.pageNum = responseData.result.pageNum
            this.selectedDataIndex = 0
         } else {
            this.$message({
               message: responseData.message,
               type: 'error'
            });
         }
      },
      async getButtonList() {
         this.buttonList = await this.$common.getActionButton()
      },
      //---------------------------------
      addClick(val) {
         this.drugObj[val].push(JSON.parse(JSON.stringify(this[val])))
         if (val == 'bydetails') {
            this.selectedDetailsIndex1 = this.drugObj[val].length - 1
            this.$nextTick(() => {
               this.tableNextFocus('bgmName1', this.selectedDetailsIndex1)
            })
         } else if (val == 'hydetails') {
            this.selectedDetailsIndex = this.drugObj[val].length - 1
            this.$nextTick(() => {
               this.tableNextFocus('bgmName', this.selectedDetailsIndex)
            })
         }
      },
      delClick(val, index) {
         this.drugObj[val].splice(this[index], 1)
         this[index] = 0
      },
   },
   //生命周期 - 创建完成（可以访问当前this实例）
   created() {
      var objs = this.$common.getSearchData(this.formList.drugReport, 'page', "rows", 30)
      for (const key in objs) {
         this.$set(this.getRequestData, key, objs[key])
      }
      this.getDataList()
      this.getButtonList()

   },
   //生命周期 - 挂载完成（可以访问DOM元素）
   mounted() {

   },
   beforeCreate() { }, //生命周期 - 创建之前
   beforeMount() { }, //生命周期 - 挂载之前
   beforeUpdate() { }, //生命周期 - 更新之前
   updated() { this.tableHeight = this.$common.getTableHeight() }, //生命周期 - 更新之后
   beforeDestroy() { }, //生命周期 - 销毁之前
   destroyed() { }, //生命周期 - 销毁完成
   activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style  scoped>
ul {
   list-style: none;
}
.box {
   padding: 10px;
}
.space_between {
   display: flex;
   align-items: center;
   justify-content: space-between;
}
.align_items_center {
   display: flex;
   align-items: center;
}
.align_items_start {
   display: flex;
}
.marginTop {
   margin-top: 5px;
}
.box_center {
   border: 1px solid #000;
   margin-top: 5px;
}
.ul {
   display: flex;
}

.ul_li {
   width: calc(100vw / 6);
}
.ul_li1 {
   width: calc(100vw / 3);
}
.ul_li2 {
   width: calc(100vw / 2);
   border-top: 1px solid #000;
}
.ul_li3 {
   width: 100vw;
   border-top: 1px solid #000;
}
.ul_li4 {
   width: 100vw;
}
.ul_li5 {
   border-top: 1px solid #000;
}
.ul .li {
   text-align: center;
   padding: 5px;
   border-right: 1px solid #000;
   border-bottom: 1px solid #000;
}
.ul .ul_li6 {
   border-bottom: none;
}
.ul .li:last-child {
   border-right: none;
}
.li_title {
   flex-shrink: 0;
}
.table {
   border-top: 1px solid #000;
}
.table .btn {
   margin-bottom: 5px;
}
::v-deep .el-radio {
   margin-right: 10px;
}
::v-deep .el-radio__label {
   padding-left: 5px;
}
::v-deep .el-checkbox {
   margin-right: 10px;
}
::v-deep .el-checkbox__label {
   padding-left: 5px;
}
/* .input ::v-deep .el-input__inner{
    border: none;
    border-radius: 0;
    border-bottom: 1px solid #000;
}
.input ::v-deep .el-input__inner:focus{
    border-bottom: 1px solid #409EFF;
} */
.floor {
   display: flex;
   align-items: center;
   justify-content: center;
}
</style>